import { createAction } from 'redux-api-middleware'

import { HUBBLE_API_TOKEN } from '../../../store/middleware/APIUrl'

const Types = {
    DEVICE_HISTORY_NOTES_STORE: {
        request: 'DEVICE_HISTORY_NOTES_STORE##REQUEST',
        success: 'DEVICE_HISTORY_NOTES_STORE##SUCCESS',
        failure: 'DEVICE_HISTORY_NOTES_STORE##FAILURE',
    },
}

/**
 *Store a new history note
 * @param {Object} note Note details
 * @param {String} note The body of the note
 * @param {String} [parent_id] History Note ID in case is a reply
 * @param {String} deviceId Device ID
 * @param {Number} historyId Device history ID
 */
function storeHistoryNote({ note, parent_id }, deviceId, historyId) {
    const body = JSON.stringify({
        note,
        parent_id,
        sticky: false,
    })

    return createAction({
        body,
        endpoint: `${HUBBLE_API_TOKEN}/devices/${deviceId}/history/${historyId}/notes`,
        method: 'POST',
        types: [
            Types.DEVICE_HISTORY_NOTES_STORE.request,
            {
                type: Types.DEVICE_HISTORY_NOTES_STORE.success,
                meta: { historyId, parentId: parent_id },
            },
            Types.DEVICE_HISTORY_NOTES_STORE.failure,
        ],
    })
}

export { Types, storeHistoryNote }
